import { useTheme } from '@material-ui/core';
import * as React from 'react';
import { useEffect } from 'react';
import ChartLegend from '../../../../../components/muiLegacy/Charts/ChartLegend';
import TopKeywordsTable from '../../../../../components/muiLegacy/Charts/TableChart/TopKeywordsTable';
import { AnalysisChartLoading } from '../../../AnalysisChartLoading';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import { ChartProps } from '../../../AnalysisList';
import {
  LegendIntervalsGq,
  volumeIntervals,
  volumeSegmentNames,
} from '../../../IntervalsAndColorsLogic';
import NotEnoughData from '../../NotEnoughData';
import NotEnoughTagGroups from '../../NotEnoughTagGroups';

export interface TopKeywordsByVolumeProps extends ChartProps { }

const TopKeywordsByVolume: React.FC<TopKeywordsByVolumeProps> = ({
  project,
  analysisFilterState,
  setAnalysisFilterState,
  palette,
}) => {
  // Adjust shown filters
  useEffect(
    () =>
      setAnalysisFilterState((prev) => ({
        ...prev,
        shownFields: {
          showTagGroupIds: true,
          showSerpOnly: true,
          showLimitItems: true,
        },
      })),
    []
  );

  // Fetch data
  const tagGroupQuery = projectsApiService.queries.analysis.useGetTopKeywords({
    projectId: project.id,
    limitItems: analysisFilterState?.limitItems,
    serpOnly: analysisFilterState?.serpOnly,
    tagGroupIds: analysisFilterState?.tagGroupIds,
  });

  const tagGroupLoading = tagGroupQuery?.query?.loading;
  const tagGroupData = tagGroupQuery?.result?.topKeywords;

  // Structure data
  const chartData = tagGroupData?.map((tg) => ({
    id: tg.id,
    name: tg.name,
    keywords: tg.keywords?.map((k) => ({
      id: k.id,
      name: k.keyword.toString(),
      volume: k.volume,
    })),
  }));

  //Styling
  const colorScheme = [...palette.performanceScale].slice(0, volumeSegmentNames.length);

  const chartLegend: LegendIntervalsGq[] = volumeIntervals.map((x, index) => ({
    name: volumeSegmentNames[index],
    start: x.start,
    end: x.end,
    bgcolor: colorScheme[index],
    color: '#fff',
  }));

  // Render
  if (tagGroupLoading) {
    return <AnalysisChartLoading />;
  }

  if (!analysisFilterState?.tagGroupIds?.length) {
    return <NotEnoughTagGroups />;
  }

  if (!tagGroupData?.some((tg) => tg.keywords?.some((k) => k.volume > 0))) {
    return <NotEnoughData />;
  }

  return (
    <div data-screenshot-id="chart-loaded">
      <ChartLegend intervals={chartLegend} />
      <TopKeywordsTable
        chartData={chartData}
        showRanks={false}
        limitItems={analysisFilterState?.limitItems}
        palette={palette}
      />
    </div>
  );
};

export default TopKeywordsByVolume;
